import { useState } from "react";
import { useSelector } from "react-redux";
import { selectProfileAvatarUrl } from "../../app-main/selectors/profile.selectors";
import { injectIntl, intlFormatPropTypes } from "react-intl";

import { AvatarUpload } from "@ps-design-system/components/AvatarUpload";
import { useDispatch } from "react-redux";
import { selectAuthAccessToken } from "../../app-main/selectors/auth.selectors";
import { updateProfile } from "../../app-main/actions/profile";

import { Text } from "@ps-design-system/components/Text";

type ProfileAvatarProps = {
  intl: intlFormatPropTypes;
};

const ProfileAvatar = ({ intl }: ProfileAvatarProps) => {
  const dispatch = useDispatch();
  const avatarUrl = useSelector(selectProfileAvatarUrl);
  const accessToken = useSelector(selectAuthAccessToken);

  const [error, setError] = useState<string>("");

  const handleOnSuccess = (result: { secure_url?: string }) => {
    const avatar = result.secure_url?.replace(
      "upload/",
      "upload/c_crop,g_custom/",
    );
    dispatch(updateProfile(accessToken, { avatar_url: avatar })).catch(() =>
      setError(
        intl.formatMessage({
          id: "hosting.profile_page.avatar_upload_error",
          defaultMessage:
            "Something went wrong, please try again. If the problem persists please refresh.",
        }),
      ),
    );
  };

  return (
    <div className="tw-flex tw-flex-row tw-items-center tw-gap-8">
      <div>
        <AvatarUpload
          defaultAvatarUrl={avatarUrl || ""}
          intl={intl}
          testId="avatarUpload-host-profile"
          onUploadSuccess={handleOnSuccess}
        />
      </div>
      {error && (
        <div>
          <Text className="tw-text-red-800 tw-mb-8 tw-body-1">{error}</Text>
        </div>
      )}
    </div>
  );
};

export default injectIntl(ProfileAvatar);
